const parseCardDetails = (cardDetails, key = null) => {
    try {
        const parsedCardDetails = JSON.parse(cardDetails);

        if (parsedCardDetails){
            if (key){
                return parsedCardDetails[key];
            }

            return parsedCardDetails;
        }
    }catch (err){
        return null;
    }
};

const brandLabels = {
    visa: "Visa",
    mastercard: "Mastercard",
    amex: "American Express",
    discover: "Discover",
    diners: "Diners Club",
    jcb: "JCB",
    unionpay: "UnionPay",
    cartes_bancaires: "Cartes Bancaires",
    eftpos: "Eftpos",
    unknown: "Unknown"
};

const brandIconPositions = {
    visa: "2px",
    mastercard: "-48px",
    american_express: "-99px",
    discover: "-150px",
    diners_club: "-200px",
    jcb: "-302px",
    union_pay: "-251px",
    cartes_bancaires: "-352px",
    eftpos: "-403px",
    unknown: "-454px"
};

export const cardBrandBgPosition = (cardDetails) => {
    const data = parseCardDetails(cardDetails);

    if (data && brandIconPositions[data.display_brand]){
        return brandIconPositions[data.display_brand];
    }else {
        return '-454px'
    }
};

export const cardBrandLabel = (cardDetails) => {
    const data = parseCardDetails(cardDetails);

    if (data && brandLabels[data.brand]){
        return brandLabels[data.brand];
    }else {
        return '';
    }
};

export const cardExpiry = (cardDetails) => {
    const data = parseCardDetails(cardDetails);

    if (data){
        let month = data.exp_month;
        if (month < 10){
            month = `0${month}`;
        }
        return `${month}/${data.exp_year}`;
    }else {
        return '';
    }
}